import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import { SwiperClass } from "core/classes/swiper/swiper.class";
import { MediaQueryPublisher } from "core/classes/media.query.publisher.class";
import { SpinnerClass } from "core/classes/spinner.class";

$(window).on("wallpaper:advert", function() {
  if (!Abacus.PreventDefault.SPIN2VideoScroller) {
    $(".videoPreview-list").each(function() {
      Abacus.VideoScroller = new VideoScroller(this, MediaQueryPublisher);
    });
  }
});

$(document).ready(function() {
  if (!Abacus.PreventDefault.SPIN2VideoScroller) {
    $(".videoPreview-list").each(function() {
      Abacus.VideoScroller = new VideoScroller(this, MediaQueryPublisher);
    });
  }
});

let VideoScrollerOptions = {
  scrollerControls: {
    previous: "li.previous",
    next: "li.next"
  },
  activeScrollerClass: "active",
  swiper: {
    slideClass: "swiper-slide",
    visibilityFullFit: true,
    slidesPerView: "auto",
    simulateTouch: false,
    roundLengths: true,
    onSlideClick: function() {},
    onTouchEnd: function() {}
  }
};

class VideoScroller extends Class {
  constructor(element, mqp, options) {
    super();
    this.element = $(element);
    this.mediator = $({});
    this.setOptions(VideoScrollerOptions, options);
    this.setupPreEvents();
    this.mqp = mqp;
    this.scroller = new SwiperClass(this.element, this.mediator, {
      swiper: this.options.swiper
    });
    this.setupEvents();
    this.setupButtons();
    this.init();
  }

  init() {
    if (this.scroller) return;
  }

  setupPreEvents() {
    var self = this;
    this.mediator.on("swiperPreInit", function() {});
  }

  setupButtons() {
    var self = this;

    this.element
      .find(this.options.scrollerControls.previous)
      .off()
      .on("click", function(evt) {
        evt.preventDefault();
        self.scroller.previous();
        self.checkButtons();
      });

    this.element
      .find(this.options.scrollerControls.next)
      .off()
      .on("click", function(evt) {
        evt.preventDefault();
        self.scroller.next();
        self.checkButtons();
      });

    this.scroller.swiper.on("touchEnd", function(swiper) {
      self.checkButtons();
    });

    $(window).on("resize", function(e, breakpoint) {
      self.refresh();
    });
  }

  setupEvents() {
    if (this.scroller.swiper.isBeginning && this.scroller.swiper.isEnd) {
      this.element.addClass("swiper-hide-controls");
    }
    this.mediator.on("swiperLoaded", (evt, element) => {
      // this.checkVisible();
      if (this.options.hasPagination) {
        this.setupButtons();
      }
    });
  }

  refresh() {
    var self = this;
    setTimeout(function() {
      // self.scroller.reInit();
      //self.scroller.swiper.updateActiveSlide();
      // remaining methog from old version of swipper
      // which is not supported anymore, so we shuld use the new one,
      // i.e. swiper.update();
      self.scroller.swiper.update();
      self.checkButtons();
      // self.checkVisible();
    }, 0);
  }

  // checkVisible() {
  //   if (
  //     this.scroller.swiper.slides.length <=
  //     this.scroller.swiper.visibleSlides.length
  //   ) {
  //     this.element
  //       .find(this.options.scrollerControls.next)
  //       .addClass("disabled");
  //     this.element
  //       .find(this.options.scrollerControls.previous)
  //       .addClass("disabled");
  //     this.element.addClass("noExtra");
  //   } else if (
  //     this.scroller.swiper.slides.length >
  //     this.scroller.swiper.visibleSlides.length
  //   ) {
  //     this.element
  //       .find(this.options.scrollerControls.next)
  //       .removeClass("disabled");
  //     this.element
  //       .find(this.options.scrollerControls.previous)
  //       .removeClass("disabled");
  //     this.element.removeClass("noExtra");
  //   }
  // }

  checkButtons(button) {
    if (this.scroller.swiper.isBeginning) {
      this.element.addClass("swiper-ready noExtra");
      this.element
        .find(this.options.scrollerControls.previous)
        .addClass("disabled");
    } else {
      this.element
        .find(this.options.scrollerControls.previous)
        .removeClass("disabled");
    }

    if (this.scroller.swiper.isEnd) {
      this.element.removeClass("swiper-ready noExtra");
      this.element
        .find(this.options.scrollerControls.next)
        .addClass("disabled");
    } else {
      this.element
        .find(this.options.scrollerControls.next)
        .removeClass("disabled");
    }

    // this.checkStart = this.scroller.swiper.activeIndex <= 0 ? true : false;
    // this.checkEnd =
    //   this.scroller.swiper.activeIndex +
    //     this.scroller.swiper.visibleSlides.length >=
    //   this.scroller.swiper.slides.length
    //     ? true
    //     : false;
    // if (this.checkStart) {
    //   this.element.addClass("swiper-ready");
    //   this.element
    //     .find(this.options.scrollerControls.previous)
    //     .addClass("disabled");
    //   this.element
    //     .find(this.options.scrollerControls.next)
    //     .removeClass("disabled");
    // }
    // if (this.checkEnd) {
    //   this.element.removeClass("swiper-ready");
    //   this.element
    //     .find(this.options.scrollerControls.previous)
    //     .removeClass("disabled");
    //   this.element
    //     .find(this.options.scrollerControls.next)
    //     .addClass("disabled");
    // }

    // if (this.checkStart && this.checkEnd)
    //   this.element.find(".controls li").removeClass("disabled");
    // if (!this.checkStart && !this.checkEnd)
    //   this.element.find(".controls li").removeClass("disabled");

    // if (
    //   this.scroller.swiper.activeIndex == 0 &&
    //   this.scroller.swiper.slides.length ==
    //     this.scroller.swiper.visibleSlides.length
    // ) {
    //   if (button == "next") {
    //     this.element.removeClass("swiper-ready");
    //     this.element
    //       .find(this.options.scrollerControls.previous)
    //       .removeClass("disabled");
    //     this.element
    //       .find(this.options.scrollerControls.next)
    //       .addClass("disabled");
    //   } else {
    //     this.element.addClass("swiper-ready");
    //     this.element
    //       .find(this.options.scrollerControls.previous)
    //       .addClass("disabled");
    //     this.element
    //       .find(this.options.scrollerControls.next)
    //       .removeClass("disabled");
    //   }
    // }
  }

  updateScroller(index) {
    this.scroller.goToSlide(index);
  }
}

export { VideoScroller };



// WEBPACK FOOTER //
// ./Javascript/core/classes/spin2/spin.video.class.js